'use client'

import { useTranslation } from 'react-i18next'
import { usePathname, useRouter } from 'next/navigation'

import { trackClickAllProducts } from 'app/components/shared/Analytics/segment'
import { Button } from 'components/ui/Buttons/Button'

const SeeAllProductsButton = (): JSX.Element => {
  const { t } = useTranslation()
  const router = useRouter()
  const pathname = usePathname()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleBrowseLinkClick = async (event: any) => {
    event.preventDefault()
    await trackClickAllProducts(pathname ?? '')
    router.push('/browse')
  }

  return (
    <>
      <Button href="/browse" onClick={handleBrowseLinkClick}>
        {t('common:seeAllProducts')}
      </Button>
    </>
  )
}

export default SeeAllProductsButton
